<div *ngIf="loading$ | async" class="spinner-container">
  <mat-spinner class="idm-spinner" [diameter]="100"></mat-spinner>
</div>
<router-outlet></router-outlet>
